export default __webpack_public_path__ + "static/go@mob-2952ac03c290f7e8a41485a46037bca6.svg";